// source: pbtypes/vehicle/infrastructure/flight_deck/return_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.flight_deck.ReturnSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.ReturnSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.ReturnSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.ReturnSettings.displayName = 'proto.flight_deck.ReturnSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.ReturnSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.ReturnSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.ReturnSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.ReturnSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
faceForward: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
minimumHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
globalPathfinderReturnHeightAgl: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
waitTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
ascendFromCurrentHeight: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
landOnceReturned: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
waitTimeBeforeLand: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
dontReturnOnLostComms: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
useBacktrack: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
useGlobalPathfinder: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
lowBatteryAutoRth: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
dontDescend: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
dontReturnOnLostCommsInAtti: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
attiReturnAltAgl: jspb.Message.getFieldWithDefault(msg, 13, 0),
cancelAttiReturnWithTimer: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
cancelAttiReturnWaitTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.ReturnSettings}
 */
proto.flight_deck.ReturnSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.ReturnSettings;
  return proto.flight_deck.ReturnSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.ReturnSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.ReturnSettings}
 */
proto.flight_deck.ReturnSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFaceForward(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinimumHeight(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGlobalPathfinderReturnHeightAgl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWaitTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSpeed(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAscendFromCurrentHeight(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLandOnceReturned(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWaitTimeBeforeLand(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDontReturnOnLostComms(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseBacktrack(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseGlobalPathfinder(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLowBatteryAutoRth(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDontDescend(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDontReturnOnLostCommsInAtti(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttiReturnAltAgl(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelAttiReturnWithTimer(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCancelAttiReturnWaitTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.ReturnSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.ReturnSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.ReturnSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.ReturnSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFaceForward();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMinimumHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getGlobalPathfinderReturnHeightAgl();
  if (f !== 0.0) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = message.getWaitTime();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getAscendFromCurrentHeight();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLandOnceReturned();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getWaitTimeBeforeLand();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getDontReturnOnLostComms();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getUseBacktrack();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getUseGlobalPathfinder();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getLowBatteryAutoRth();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getDontDescend();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getDontReturnOnLostCommsInAtti();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getAttiReturnAltAgl();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getCancelAttiReturnWithTimer();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCancelAttiReturnWaitTime();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
};


/**
 * optional bool face_forward = 1;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getFaceForward = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setFaceForward = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional float minimum_height = 2;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getMinimumHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setMinimumHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float global_pathfinder_return_height_agl = 17;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getGlobalPathfinderReturnHeightAgl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setGlobalPathfinderReturnHeightAgl = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional float wait_time = 3;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getWaitTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setWaitTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float speed = 4;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool ascend_from_current_height = 5;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getAscendFromCurrentHeight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setAscendFromCurrentHeight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool land_once_returned = 6;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getLandOnceReturned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setLandOnceReturned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional float wait_time_before_land = 7;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getWaitTimeBeforeLand = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setWaitTimeBeforeLand = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional bool dont_return_on_lost_comms = 8;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getDontReturnOnLostComms = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setDontReturnOnLostComms = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool use_backtrack = 9;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getUseBacktrack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setUseBacktrack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool use_global_pathfinder = 16;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getUseGlobalPathfinder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setUseGlobalPathfinder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool low_battery_auto_rth = 10;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getLowBatteryAutoRth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setLowBatteryAutoRth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool dont_descend = 11;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getDontDescend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setDontDescend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool dont_return_on_lost_comms_in_atti = 12;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getDontReturnOnLostCommsInAtti = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setDontReturnOnLostCommsInAtti = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional int32 atti_return_alt_agl = 13;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getAttiReturnAltAgl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setAttiReturnAltAgl = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool cancel_atti_return_with_timer = 14;
 * @return {boolean}
 */
proto.flight_deck.ReturnSettings.prototype.getCancelAttiReturnWithTimer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setCancelAttiReturnWithTimer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional float cancel_atti_return_wait_time = 15;
 * @return {number}
 */
proto.flight_deck.ReturnSettings.prototype.getCancelAttiReturnWaitTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ReturnSettings} returns this
 */
proto.flight_deck.ReturnSettings.prototype.setCancelAttiReturnWaitTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


goog.object.extend(exports, proto.flight_deck);
